import {Component, OnDestroy, OnInit, Input, Output, EventEmitter, ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EventManager, AccountService } from 'src/app/core';
import { FormBuilder, Validators } from '@angular/forms';
import { EditComponent } from 'src/app/shared/components/edit.component';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ConfirmPopUpComponent } from 'src/app/shared/components/confirm-popup/confirm-popup.component';
import { MasterDataProductService } from '../../services/master-data-product.service';
import { ProductService } from '../../product.service';
import { EditFeeComponent } from '../edit-fee/edit-fee.component';

@Component({
  selector: 'app-fee-transfer',
  templateUrl: './fee-transfer.component.html',
  styleUrls: ['./fee-transfer.component.scss']
})
export class FeeTransferComponent extends EditComponent implements OnInit , OnDestroy {
  @Input() isChildren: boolean = false;
  @Input() relationalOperators: any;
  @Input() name: any;
  @Output() result: EventEmitter<any> = new EventEmitter();
  @ViewChild(EditFeeComponent, { static: true }) editFeeComponent: EditFeeComponent;
  sipName: string;
  fees: any[] = [];
  restFees: any[] = [];
  products: any[] = [];
  programs: any[] = [{id: 1, name: 'Linh Hoạt', code: 'NORMAL'}, { id: 2, name: 'Định kỳ', code: 'SIP'}];
  subscriptions: Subscription[] = [];
  TRANSFER_FEE = 'TRANSFER_FEE';
  selectedProgram: any; // PRODUCT , SIP
  destProduct: any;
  destProgram: any = this.programs[0];
  destProgramId: string = this.destProgram.id;
  schemeId: any;
  sipId: any;
  isLoad: boolean = false;
  sourcePrograms: any[] = [{id: 1, name: 'Linh Hoạt', code: 'NORMAL'}, { id: 2, name: 'Định kỳ', code: 'SIP'}];
  selectedItem: any;
  body: any;
  constructor(
    private fb: FormBuilder,
    private productService: ProductService,
    public masterDataProductService: MasterDataProductService,
    public eventManager: EventManager,
    public route: ActivatedRoute,
    public router: Router,
    public toast: ToastrService,
    public modalService: NzModalService,
  ) {
    super(eventManager, route);
  }

  ngOnInit(): void {
    const params = this.route.snapshot.params;
    this.id = params.id;
    this.name = params.name || this.name;
    this.sipName = params.sipName;
    this.sipId = params.sipId;
    if (this.sipId) {
      this.selectedProgram = this.sourcePrograms[1];
    } else {
      this.selectedProgram = this.sourcePrograms[0];
    }
    this.subscriptions = [
      this.eventManager.subscribe('get-transfer-list-result' , (res) => {
        this.setTransferList(res.content);
      }),
    ];
    this.getRelationalOperator();
    this.getProducts();
  }
  ngOnDestroy() {
    this.eventManager.destroys(this.subscriptions);
  }
  getRelationalOperator() {
    return this.masterDataProductService.getRelationalOperator()
    .subscribe(((res: any) => {
      this.relationalOperators = res.list;
      this.relationalOperators.forEach((operator) => {
        switch (operator.name) {
          case '<=':
          operator.reverseOperator = '>=';
          break;
          case '<':
          operator.reverseOperator = '>';
          break;
          case '>=':
          operator.reverseOperator = '<=';
          break;
          case '>':
          operator.reverseOperator = '<';
          break;
        }
      });
      return res;
    }));
  }
  getProducts() {
    this.productService.getProductsInIssuer(this.id)
    .subscribe((res: any) => {
      this.products = res.body ? res.body.data : [];
      // const find = this.products.find(item => item.destination) || {};
      // this.destProduct = find.id || undefined;
      // if (this.destProduct) {
      //   this.getDetail();
      // }
    })
  }
  chooseProduct() {
    this.programs = this.destProduct.programList || [];
    this.destProgram = this.programs.find(program => program.schemeId === this.destProgramId);
    this.getDetail();
  }
  chooseProgram() {
    this.destProgram = this.programs.find(program => program.schemeId === this.destProgramId);
    this.getDetail();
  }
  getDetail() {
    this.fees = [];
    this.schemeId = this.selectedProgram.id;
    if (!(this.destProduct || {}).id || !this.destProgram || !this.selectedProgram) {
      return;
    }
    this.body = {
      productId: this.id,
      destProductId: this.destProduct.id,
      schemeCode: this.selectedProgram.code,
      type: 'TRANSFER',
      page: 1,
      size: 1000
    };
    this.isLoad = true;
    if (this.isChildren) {
      this.eventManager.broadcast({
        name: 'get-transfer-list',
        content: this.body
      })
      return;
    }
    this.getTransferFeeList();
  }
  getTransferFeeList() {
    this.productService.getTransferFeeList(this.body)
    .subscribe((res: any) => {
      this.isLoad = false;
      const fees = (res.body ? res.body.data.list : []).filter((item) => {
        return item.destSchemeId.id === this.destProgramId;
      });
      if (fees.length) {
        this.setTransferList(fees);
      } else {
        this.fees = [];
        this.toast.warning('Hiện tại không có phí chuyển đổi cho quỹ mục tiêu này');
      }
    })
  }
  setTransferList(fees) {
    this.restFees = [];
    this.fees = fees.filter((fee) => {
      fee.programId = fee.programId || (fee.destSchemeId || {}).id || fee.destSchemeId; 
      const result = fee.schemeId === this.schemeId || (fee.schemeId || {}).id === this.schemeId;
      if (!result && (fee.schemeId || {}).code === (this.selectedProgram || {}).code) {
        this.restFees.push(fee);
      }
      return result;
    });
  }
  updateForm() {
    this.isSaved = false;
  }
  disabledButton() {
    this.errors.destProduct = !this.destProduct;
    return super.disabledButton();
  }
  getData() {
    this.isSaved = true;
  }
  save() {
    const feeEmitData = this.editFeeComponent.emitData();
    if (this.disabledButton()) {
      return null;
    }
    const fees = [...feeEmitData.map((item) => {
      item.schemeId = (this.selectedProgram || {}).id;
      item.destSchemeId = 1;
      item.typeCode = 'TRANSFER';
      return item;
    }), ...this.restFees.map((item) => {
      item.schemeId = (item.schemeId || {}).id;
      item.destSchemeId = 1;
      return item;
    })];
    let max = 0;
    const invalidFee = fees.every((fee) => {
      if (max < fee.endValue) {
        max = fee.endValue;
      }
      return max === fee.endValue;
    })
    if (!fees.length) {
      this.toast.error('Vui lòng nhập đầy đủ và đúng phí!');
      return null;
    }
    const body = {
      productId: this.id,
      destProductId: this.destProduct.id,
      schemeId: this.schemeId, // new fee
      schemeCode: this.selectedProgram.code, // PRODUCT OR SIP
      type: 'TRANSFER',
      productFeeInDtoList : fees,
      invalidFee
    };
    if (this.isChildren) {
      return body;
    }
    return this.productService.saveTransferFeeList(body)
    .subscribe(((res: any) => {
      this.toast.success('Lưu chuyển đổi phí thành công!');
      return res;
    }));
  }
  clearFee() {
    this.fees = [];
  }
  confirmDelete() {
    const modal = this.modalService.create({
      nzTitle: '',
      nzWidth: '650px',
      nzStyle: {top: '20px'},
      nzContent: ConfirmPopUpComponent,
      nzData: {
        title: 'Bạn có chắc muốn xóa phí chuyển đổi này không ?'
      },
      nzOnOk: (() => { this.delete() })
    });
  }
  delete() {
    const body = {
      productId: this.id, 
      schemeCode: this.selectedProgram.code,
      destProductId: this.destProduct.id, 
      destSchemeId: 1,
      type: 'TRANSFER'
    };
    this.productService.deleteTransferFeeList(body)
    .subscribe((res) => {
      this.toast.success('Xoá Phí Chuyển Đổi Thành Công !');
      this.fees = [
        { }, {}
      ];
    });
  }
}
